// test2326
(2326 && 0);
